import { render } from "./DireccionesModal.vue?vue&type=template&id=0234c1ea"
import script from "./DireccionesModal.vue?vue&type=script&lang=js"
export * from "./DireccionesModal.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__